import { createFeatureFlagHelpers } from '@ramp106/omrjs-core-ui/posthog'

import { ph, posthogReady } from '@/services/posthog'

export const { useFeatureFlag, isFeatureEnabled, useExperiment, getExperimentVariant } = createFeatureFlagHelpers(ph, posthogReady, {
  app: 'manager',
})
